type Props = {
  id?: string;
  label: any;
  href: string;
};

/**
   @function Button
   renders button with custom style and function
   @param {string} id - component id
   @param {string} label - label rendered on Component
   @param {className} - extended className for component 
   @returns {React.Node}
 */
export default function WebLink({ id = "", label = "", href = "" }: Props) {
  return (
    <a
      className="px-1 text-blue-800 underline decoration-dotted decoration-1 underline-offset-[6px] transition-all hover:text-blue-600 hover:underline hover:decoration-blue-600 hover:decoration-solid"
      id={id}
      target="_blank"
      rel="noreferrer"
      href={href}
    >
      {label}
    </a>
  );
}
